import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitosaptaracabs() {



  const cardData = {
    keyword: " Mumbai to Saputara Cabs",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Saputara cab services, providing safe, comfortable, and affordable long-distance travel for families, couples, pilgrims, and group travelers. Saputara is a beautiful hill station located in the Dang district of Gujarat, approximately 250–270 km from Mumbai, and is known for its cool climate, greenery, waterfalls, and peaceful surroundings. Our professional drivers and well-maintained vehicles ensure a smooth and stress-free journey through scenic highways and ghat sections. We offer flexible travel options including one-way drops, round trips, weekend packages, and customized hill station tours. Our fleet includes sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Saputara cab service.",

"topPlaces": [
  {
    "title": "Saputara Lake",
    "description": "Saputara Lake is the central attraction of Saputara hill station, surrounded by lush greenery and walking paths that make it ideal for boating, evening strolls, and family outings. Visitors traveling from Mumbai enjoy the calm atmosphere here after a long road journey, with paddle boating, food stalls, and scenic viewpoints adding to the relaxing experience."
  },
  {
    "title": "Sunset Point",
    "description": "Sunset Point in Saputara is one of the most famous viewpoints offering breathtaking views of the Western Ghats and surrounding valleys. It is especially popular during evening hours when the sky turns orange and pink, making it a perfect photography and relaxation spot for tourists arriving by cab from Mumbai."
  },
  {
    "title": "Governor’s Hill",
    "description": "Governor’s Hill is a scenic elevated viewpoint in Saputara known for its panoramic landscapes, cool breeze, and peaceful trekking paths. It offers a refreshing escape into nature and is a must-visit spot for travelers looking to explore Saputara’s natural beauty after reaching from Mumbai."
  },
  {
    "title": "Gira Waterfalls",
    "description": "Gira Waterfalls is a stunning seasonal waterfall located near Saputara, especially beautiful during the monsoon when water flows with full force. It is surrounded by dense greenery and rocky terrain, making it a popular attraction for adventure lovers and nature enthusiasts traveling from Mumbai."
  },
  {
    "title": "Artist Village Saputara",
    "description": "Artist Village showcases the tribal culture and handicrafts of the Dang region, offering visitors a glimpse into local art, bamboo crafts, paintings, and traditional lifestyle. It is an educational and cultural stop that adds depth to the Saputara travel experience for tourists from Mumbai."
  },
  {
    "title": "Step Garden",
    "description": "Step Garden in Saputara is a beautifully designed terraced garden with well-maintained flower beds, pathways, and seating areas. It is a peaceful location ideal for family visits, photography, and relaxation after a long journey from Mumbai."
  },
  {
    "title": "Saputara Ropeway",
    "description": "Saputara Ropeway offers an exciting aerial view of the entire hill station, connecting the valley to the hilltop points. It provides a thrilling experience for tourists and is one of the most popular attractions for visitors traveling by cab from Mumbai."
  },
  {
    "title": "Hatgadh Fort",
    "description": "Hatgadh Fort is a historical site near Saputara offering panoramic views of the surrounding hills and valleys. It is a great spot for trekking and exploring ancient architecture, attracting adventure seekers and history lovers."
  },
  {
    "title": "Rose Garden",
    "description": "Rose Garden in Saputara is a colorful attraction filled with various types of roses and ornamental flowers. It is a peaceful and refreshing place for nature lovers and families looking for a relaxing outing after reaching Saputara from Mumbai."
  },
  {
    "title": "Table Point",
    "description": "Table Point is a flat plateau offering wide panoramic views of Saputara’s valleys and hills. It is a popular picnic spot where visitors enjoy horse rides, snacks, and open scenic landscapes, making it a favorite stop for Mumbai travelers."
  }
],






services: [
  {
    name: "Mumbai to Saputara Cab",
    description: "Mumbai to Saputara cab service offers a comfortable and scenic journey to Gujarat’s popular hill station. Ideal for families, couples, and weekend travelers, this service ensures smooth travel through highways and ghat sections. Professional drivers and well-maintained vehicles enhance safety. It guarantees a relaxing and enjoyable trip."
  },
  {
    name: "Mumbai to Saputara Taxi",
    description: "Mumbai to Saputara taxi provides reliable and private transportation for hill station travel. This service includes door-to-door pickup and flexible travel schedules. Comfortable vehicles ensure a pleasant journey. It guarantees a hassle-free experience."
  },
  {
    name: "Mumbai to Saputara Cab Service",
    description: "Mumbai to Saputara cab service offers professional travel solutions with multiple vehicle options. This service is ideal for family vacations, group trips, and leisure travel. Clean vehicles and experienced drivers ensure comfort. It ensures a smooth journey."
  },
  {
    name: "Mumbai to Saputara Taxi Service",
    description: "Mumbai to Saputara taxi service ensures dependable transportation with comfortable seating and experienced chauffeurs. This service is ideal for long-distance hill station trips. Flexible booking options enhance convenience. It guarantees a safe journey."
  },
  {
    name: "Cab from Mumbai to Saputara",
    description: "Cab from Mumbai to Saputara offers a convenient way to travel between cities with complete comfort. This service is ideal for those who prefer road trips with scenic views. Professional drivers ensure safe travel. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Saputara",
    description: "Taxi from Mumbai to Saputara provides reliable long-distance travel for individuals and groups. This service ensures smooth travel through hilly terrains with experienced drivers. Comfortable seating enhances the journey. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Saputara Cab Booking",
    description: "Mumbai to Saputara cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Saputara Taxi Booking Online",
    description: "Mumbai to Saputara taxi booking online provides a quick and convenient way to plan your trip. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Saputara Cab Price",
    description: "Mumbai to Saputara cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Saputara Taxi Fare",
    description: "Mumbai to Saputara taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Saputara One Way Cab",
    description: "Mumbai to Saputara one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Saputara Round Trip Taxi",
    description: "Mumbai to Saputara round trip taxi provides complete travel solutions including return journeys. This service is ideal for weekend getaways and vacations. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Saputara Innova Cab",
    description: "Mumbai to Saputara Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable hill station experience."
  },
  {
    name: "Mumbai to Saputara Ertiga Cab",
    description: "Mumbai to Saputara Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Saputara Sedan Cab",
    description: "Mumbai to Saputara sedan cab is ideal for individuals and couples seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed trip."
  },
  {
    name: "Mumbai to Saputara SUV Taxi",
    description: "Mumbai to Saputara SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance on hilly routes and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Saputara Cab",
    description: "Cheap Mumbai to Saputara cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mumbai to Saputara Taxi Service",
    description: "Best Mumbai to Saputara taxi service ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mumbai to Saputara Cab", "Mumbai to Saputara Taxi"],
  ["Mumbai to Saputara Cab Service", "Mumbai to Saputara Taxi Service"],
  ["Cab from Mumbai to Saputara", "Taxi from Mumbai to Saputara"],
  ["Mumbai to Saputara Cab Booking", "Mumbai to Saputara Taxi Booking Online"],
  ["Mumbai to Saputara Cab Price", "Mumbai to Saputara Taxi Fare"],
  ["Mumbai to Saputara One Way Cab", "Mumbai to Saputara Round Trip Taxi"],
  ["Mumbai to Saputara Innova Cab", "Mumbai to Saputara Ertiga Cab"],
  ["Mumbai to Saputara Sedan Cab", "Mumbai to Saputara SUV Taxi"],
  ["Cheap Mumbai to Saputara Cab", "Best Mumbai to Saputara Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Saputara Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Saputara cab service, perfect for hill station trips, family vacations, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained in handling ghat and hill routes, ensuring safe driving and smooth navigation to Saputara."
  },
  {
    WhyChooseheading: "Perfect for Weekend & Nature Trips",
    WhyChoosedescription: "Saputara is a popular hill station in Gujarat, and our cab service is ideal for couples, families, and group travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Saputara trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Saputara cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Hill Station Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Saputara cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Saputara cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Saputara for one-way and round trips." },
  { question: "What is the distance between Mumbai and Saputara?", answer: "The distance is approximately 250 to 270 km and takes around 6 to 7 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Saputara cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for family trips?", answer: "Yes, Saputara trips are ideal for families, couples, and group travel." },
  { question: "Do you provide ghat route experienced drivers?", answer: "Yes, our drivers are experienced in hill and ghat driving." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for weekends and holiday travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Mehta",
    feedback: "Saputara trip from Mumbai turned out better than expected. The ride with Royal Route Cabs was steady on ghats and felt safe even in rainy weather conditions.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Riddhi Shah",
    feedback: "Comfortable seating and a calm drive made the long route to Saputara enjoyable. The driver handled the hills well and we reached without any stress.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Saputara Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-saputara-cab.jpg", // replace if needed
  "description": "Book Mumbai to Saputara cab service with Royal Route Cabs for safe, comfortable, and affordable hill station travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 reliable outstation taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-saputara-cabs"
  }
};







  return (
    <div>

<Helmet>
  <title>Mumbai to Saputara Cabs | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Saputara cab with Royal Route Cabs. Safe and affordable hill station taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 outstation travel available."
  />

  <meta
    name="keywords"
    content="mumbai to saputara cab, mumbai to saputara taxi, mumbai to saputara cab service, mumbai to saputara taxi service, cab from mumbai to saputara, taxi from mumbai to saputara, mumbai to saputara cab booking, mumbai to saputara taxi booking online, mumbai to saputara cab price, mumbai to saputara taxi fare, mumbai to saputara one way cab, mumbai to saputara round trip taxi, mumbai to saputara innova cab, mumbai to saputara ertiga cab, mumbai to saputara sedan cab, mumbai to saputara suv taxi, cheap mumbai to saputara cab, best mumbai to saputara taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosaptaracabs;